import controller from './shopping-experience.controller';
import templateBase from './templates/shopping-experience-base.view.html';
// import templateAD from './templates/confirmation-order-view-adaptative.html';
import templateAD from './templates/shopping-expierience-view-adaptative.html';

let ShoppingExperienceComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        order:'<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    if(__env.adaptative) {
        return templateAD;
    } else {
        return templateBase;
    }


}

export default ShoppingExperienceComponent;



/** WEBPACK FOOTER **
 ** ./www/components/shopping-experience/shopping-experience.component.js
 **/